import { createGlobalStyle } from "styled-components";
import { theme } from "./theme";

export default createGlobalStyle`

* {
    font-family: "Inter", sans-serif;
}

*{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
}

#root {
    margin: 0 auto;
    background-color: ${theme.colors.bgBody};

    font-size: 16px;
}
body {
    overflow: hidden;
    line-height: 1.5715;
}

html {
    scroll-padding-top: 64px;
}

.MarkerClusterer__MarkerLabel {
  font-family: ${theme.text.family};
  font-weight: 600;
}

fieldset {
  border: none;
}

a {
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color .3s;
}

.wizard-helper-popup {
  .ant-popover-inner {
    padding: 24px;
  }
}
`;
